module.exports = __webpack_public_path__ + "img/user_w.86dcdd6a.svg";